/************
 READ ME

 This product can exist outside the product template - ie the landing page.
 Because the landing page version has a selector to choose between three different products
 (wintergreen, peppermint, and spearmint), there are 3 separate sections for each product.
 *This is why everything is a class and IDs are only tied to product.id/block.id
 If the template is on the product page, there is only one section.

 The way the landing page products work is it shows and hides each product section
 based on the user's selection of .productContentProductsChoice

 The way variants work is as follows:
 - There are two types of variants: one-time and subscription
 - Each variant has a pack size (1, 2, 3)
 - Each variant has a selling plan
 - The variants aren't native shopify variants, but instead unique products that are
 linked to the main product's metafields

 - Instead of swapping data between the choices, we create multiple sets of choices that
 are either visible or invisible

 - When the product form is submitted, we just find what the active variant is and submit that,
 which will already contain all the necessary data (variantSubscriptionElement)

 ************/


// GA4 view_item
dataLayer.push({ecommerce: null});
dataLayer.push({
    event: "view_item",
    ecommerce: {
        currency: Shopify.currency.active,
        value: activeVariant.price / 100,
        items: [
            {
                item_id: product.id,
                item_name: product.title,
                item_category: product.type,
                item_variant: activeVariant.title,
                price: activeVariant.price / 100,
                quantity: 1
            }
        ]
    }
});


/****************
 Update Product
 *******************/

// return the currently selected variant element
function getActiveVariantElement() {
    return document.querySelector(`.product:not(.active) .productContentFormVariant.active .productContentFormVariantItem.active`);
}

function updateProduct() {
    // there will always be 2 active variants (one for one-time and one for subscription)
    document.querySelectorAll(".productContentFormVariantItem.active").forEach(function (element, index) {
        // update pricing by matching the index of the active variant
        document.querySelectorAll(".productContentFormTypeActual")[index].innerHTML = price(element.dataset.price);
    });

    // get active subscription element
    let variantSubscriptionElement = document.querySelector(`.product:not(.active) .productContentFormVariant[data-type="subscription"] .productContentFormVariantItem.active`);

    // update first bullet with savings
    if (variantSubscriptionElement.dataset.savings !== "$0") {
        document.querySelector(".product:not(.active) .productContentFormTypeListItem").textContent = `Subscribe and save ${variantSubscriptionElement.dataset.savings}`;
    } else {
        document.querySelector(".product:not(.active) .productContentFormTypeListItem").textContent = "";
    }

    // update upsell info
    if (document.querySelector(".productBanner:not(.active)")) {
        // get active variant element to pull data from
        let variantElement = getActiveVariantElement();

        // update all fields
        document.querySelector(".productBanner:not(.active) .productBannerBodyRightOptionAmount").textContent = variantElement.dataset.buyAmount;
        document.querySelector(".productBanner:not(.active) .productBannerBodyLeftMobileAmount").textContent = variantElement.dataset.buyAmount;
        document.querySelector(".productBanner:not(.active) .productBannerBodyRightOptionInterval").textContent = variantElement.dataset.shippingInterval ?? "";
        document.querySelector(".productBanner:not(.active) .productBannerBodyLeftMobileInterval").textContent = variantElement.dataset.shippingInterval ?? "";
        document.querySelector(".productBanner:not(.active) .productBannerBodyRightATCCompare").textContent = variantElement.dataset.comparePrice ? price(variantElement.dataset.comparePrice) : "";
        document.querySelector(".productBanner:not(.active) .productBannerBodyRightATCPrice").textContent = price(variantElement.dataset.price);
    }

    // return early if b2b (the layout puts a b2b class on the html tag for Professional/Distributor customers)
    if (document.documentElement.classList.contains("b2b")) {
        return;
    }

    let variantElement = getActiveVariantElement();

    // swap the source of the first image (which will always be the product image) to the variant image if it exists
    if (variantElement.dataset.featuredImage) {
        let elements = document.querySelectorAll(".product:not(.active) .productInnerWrapVisualSwiperImage");
        if (elements.length > 0) {
            elements[0].src = variantElement.dataset.featuredImage;
        }
        // slide to that image if it exists
        let index = product.images.findIndex(image => image === variantElement.dataset.featuredImage);

        productImages.forEach(function (swiper) {
            swiper.slideTo(index);
        });
    }
}


// update pricing on load
updateProduct();

/******************
 Product Variant Select (Pack Size)
 ******************/

// when a user selects a variant (1, 2, 3, pack)
document.querySelectorAll(".productContentFormVariantItem").forEach(function (element) {
    element.addEventListener("click", function () {

        // remove active class from all variants
        document.querySelectorAll(".productContentFormVariantItem").forEach(function (element) {
            element.classList.remove("active");
        });

        // add active class to this index for all variant groups
        // this matters since if you select the 2 pack for subscription, it should also select the 2 pack for one-time
        document.querySelectorAll(`.productContentFormVariantItem[data-index="${this.dataset.index}"]`).forEach(function (element) {
            element.classList.add("active");
        });

        updateProduct();
    });
});


/*******************
 Product Purchase Type (One-Time or Subscription)
 ********************/

// - Auto select one time on whitening template
window.addEventListener('load', function () {
    if (document.querySelector('.product').classList.contains('whitening')) {
        document.querySelector('.productContentFormType[data-type="onetime"]').click();
    }
});

// auto select query params
document.addEventListener('DOMContentLoaded', function () {
    let urlParams = new URLSearchParams(window.location.search);
    let size = urlParams.get('size');
    let flavor = urlParams.get('flavor');

    if (flavor) {
        // only allow known flavors
        let validFlavors = ['wintergreen', 'peppermint', 'mild'];
        if (validFlavors.includes(flavor.toLowerCase())) {
            let flavorTarget = document.querySelector(`.productContentProductsChoice.${flavor.toLowerCase()}`);
            if (flavorTarget) flavorTarget.click();
        }
    }


    if (size) {
        // map size to index
        let sizeToIndex = {
            '1': 0,
            '3': 1,
            '5': 2
        };

        let index = sizeToIndex[size];
        if (index !== undefined) {
            let target = document.querySelector('.productContentFormVariant.active')?.querySelector(`.productContentFormVariantItem[data-index="${index}"]`);
            if (target) target.click();
        }
    }
})

// when a user toggles between one-time and subscription
document.querySelectorAll(".productContentFormType").forEach(function (element) {
    element.addEventListener("click", function () {

        // remove active class from active type
        document.querySelectorAll(".productContentFormType.active").forEach(function (element) {
            element.classList.remove("active");
        });

        // add active class to this for all sections
        document.querySelectorAll(`.productContentFormType[data-type="${this.dataset.type}"]`).forEach(function (element) {
            element.classList.add("active");
        });

        // change active variant group since there's one for each type (one-time and subscription) for all sections
        document.querySelectorAll(".productContentFormVariant.active").forEach(function (element) {
            element.classList.remove("active");
        });
        document.querySelectorAll(`.productContentFormVariant[data-type="${this.dataset.type}"]`).forEach(function (element) {
            element.classList.add("active");
        });

        // update product
        updateProduct();
    });
});


/*******************
 Product Selling Plan (1 month - 12 months)
 ********************/

// when a user selects a selling plan and is b2b user
document.querySelector(".productContentFormSelect")?.addEventListener("change", function () {
    let sellingPlanId = this.value;
    // update each variant item with the new selling plan
    document.querySelectorAll(".productContentFormVariantItem[data-selling-plan]").forEach(function (element) {
        element.setAttribute("data-selling-plan", sellingPlanId);
    });
});


/*************
 Landing Page Product Switcher
 **************/

// when a user selects a product from the landing page, show that product and hide the others
// there are three copies of each product, so we are actually looping over 3 groups of buttons
document.querySelectorAll('.productContentProductsChoice')?.forEach(function (element) {
    element.addEventListener("click", function () {

        let target = this.dataset.id;

        // remove all active classes
        document.querySelectorAll('.productContentProductsChoice').forEach(function (element) {
            element.classList.remove('active');
        });

        // add active class to the selected product choice (there are 3 of them total, not 1)
        document.querySelectorAll('.productContentProductsChoice').forEach(function (element) {
            if (element.dataset.id === target) {
                element.classList.add('active');
            }
        });

        // hide all products
        document.querySelectorAll('.product').forEach(function (element) {
            element.classList.add('active');
        });

        // hide all product banners
        document.querySelectorAll('.productBanner').forEach(function (element) {
            element.classList.add('active');
        });

        // show the selected product
        document.querySelector(`.product[data-id="${target}"]`).classList.remove('active');

        // show the selected product banner
        document.querySelector(`.productBanner[data-id="${target}"]`).classList.remove('active');


        // update product
        updateProduct();
    });
});


/************
 Dynamic Sold Out
 ************/
(function () {
    // Get the current date and time
    let currentDate = new Date();
    // let currentDate = new Date("2024-05-29T23:59:00");

    // The date everything is relative to - which is a Sunday.
    let targetDate = new Date("2024-04-28T23:59:00");

    // Increment the counter for every day that has passed
    let daysPassed = Math.floor((currentDate - targetDate) / (1000 * 60 * 60 * 24) % 7);

    // get the next monday from current date
    let nextMonday = new Date(currentDate);
    nextMonday.setDate(currentDate.getDate() + 8 - currentDate.getDay());

    // get the last monday from current date
    let lastMonday = new Date(currentDate);
    lastMonday.setDate(currentDate.getDate() + 1 - currentDate.getDay());

    // Update the text with the incremented number
    document.querySelectorAll(".percentSold")?.forEach(function (element) {
        element.textContent = daysPassed + 91;
    });

    // Update the date with the next monday
    document.querySelectorAll(".preOrderDate")?.forEach(function (element) {
        element.textContent = nextMonday.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
    });

    // Update the date with the last Monday
    document.querySelectorAll(".lastOrderDate")?.forEach(function (element) {
        element.textContent = lastMonday.toLocaleDateString('en-US', {month: 'long', day: 'numeric'});
    });
})();


/*************
 Default Quantity
 **************/

let quantity = 1;

/**************
 Product ATC
 ***************/

document.querySelectorAll(".productContentFormATC").forEach(async function (element) {
    element.addEventListener("click", async function () {
        // active variant item
        let variantElement = getActiveVariantElement();
        let formData = {};

        // check for quiz query param
        // if true, map to the quiz version of the products (Wintergreen only)
        // https://admin.shopify.com/store/livfresh-store/products/100900626435
        let urlParams = new URLSearchParams(window.location.search);
        let quiz = urlParams.get('quiz');
        if (quiz === 'true') {

            // map the 1-5 pack to the quiz SKUS
            let ogIDToQuizID = {
                // ONE TIME OG TO QUIZ
                47136226410815: 51321895354687, // 1 Pack
                47136236077375: 51321895387455, // 3 Pack,
                47136239518015: 51321895420223, // 5 Pack,
                // SUBSCRIPTION OG TO QUIZ
                47136231555391: 51321895354687, // 1 Pack
                47136236667199: 51321895387455, // 3 Pack,
                47136239714623: 51321895420223  // 5 Pack,
            }

            let quizIDToSellingPlan = {
                51321895354687: 8462008639, // 1 Pack,
                51321895387455: 8462041407, // 3 Pack,
                51321895420223: 8462139711  // 5 Pack,
            }

            let quizVariantID = ogIDToQuizID[parseInt(variantElement.dataset.variant)];
            let sellingPlanID = quizIDToSellingPlan[quizVariantID];

            // create formdata
            formData = {
                quantity: quantity,
                id: quizVariantID
            };

            // if there's a selling plan, add it
            if (document.querySelector('.productContentFormType[data-type="subscription"].active')) {
                formData.selling_plan = sellingPlanID;
            }

        } else {
            // create formdata
            formData = {
                quantity: quantity,
                id: variantElement.dataset.variant,
            };

            // check for selling plan
            if (variantElement.dataset.sellingPlan) {
                formData.selling_plan = variantElement.dataset.sellingPlan;
            }
        }


        // add loading animation
        this.classList.add("loading");

        // GA4 add_to_cart
        const sourceProduct = variantToSourceProduct[formData.id];
        dataLayer.push({ecommerce: null});
        dataLayer.push({
            event: 'add_to_cart',
            ecommerce: {
                currency: Shopify.currency.active,
                value: sourceProduct.variants[0].price * quantity / 100,
                items: [{
                    item_id: sourceProduct.id,
                    item_name: sourceProduct.title,
                    item_category: sourceProduct.type,
                    item_variant: sourceProduct.variants[0].title,
                    price: sourceProduct.variants[0].price / 100,
                    quantity: quantity,
                    subscription_item: !!formData.selling_plan,
                }],
                subscription_included: !!formData.selling_plan,
            }
        });

        // push to klavviyo
        try {
            _learnq.push(["track", "Added to Cart", {
                "$value": sourceProduct.price * quantity / 100,
                "AddedItemProductName": sourceProduct.title,
                "AddedItemProductID": sourceProduct.id,
                "AddedItemSKU": sourceProduct.variants[0].sku,
                "AddedItemCategories": sourceProduct.tags,
                "AddedItemImageURL": sourceProduct.featured_image?.src,
                "AddedItemURL": `https://getlivfresh.com/products/${product.handle}`,
                "AddedItemPrice": sourceProduct.price,
                "AddedItemQuantity": 1,
                "ItemNames": [sourceProduct.title],
                "CheckoutURL": "https://livfresh.com/checkout",
                "Items": [{
                    "ProductID": sourceProduct.id,
                    "SKU": sourceProduct.variants[0].sku,
                    "ProductName": sourceProduct.title,
                    "Quantity": quantity,
                    "ItemPrice": sourceProduct.price / 100,
                    "RowTotal": sourceProduct.price * quantity / 100,
                    "ProductURL": `https://getlivfresh.com/products/${product.handle}`,
                    "ImageURL": sourceProduct.featured_image?.src,
                    "ProductCategories": sourceProduct.tags
                }]
            }]);
        } catch (e) {
            console.log(e)
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        this.classList.remove("loading");

        // open cart
        await openCart();

    });
});


// dropdown event listeners for each of the titles
document.querySelectorAll(`.productContentDropdownsItemTitle`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});

// random number gen (23-100) for checking out now text
document.querySelectorAll(".productContentCheckingOutNum").forEach(function (element) {
    element.innerHTML = Math.floor(Math.random() * (127 - 70 + 1) + 70); // make range 70 - 127
});
// Do it every 3 seconds
setInterval(function () {
    document.querySelectorAll(".productContentCheckingOutNum").forEach(function (element) {
        element.innerHTML = Math.floor(Math.random() * (127 - 70 + 1) + 70); // make range 70 - 127
    });
}, 3000);